import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CompressionPro = () => {
  const [products, setProducts] = useState([]);
  const [compressions, setCompressions] = useState([]); // Renamed for clarity
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [compression, setCompression] = useState('');  // Corrected from category to compression
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState('');
  const [error, setError] = useState(null);

  // Fetch Compression Categories
  useEffect(() => {
    const fetchCompressions = async () => {
      try {
        const response = await axios.get('https://snapper.hxbindia.com/compression');
        setCompressions(response.data);
      } catch (error) {
        console.error('Error fetching compression categories:', error);
      }
    };
    fetchCompressions();
  }, []);

  // Fetch Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://snapper.hxbindia.com/compressionproducts');
        setProducts(response.data);
        console.log(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('compression', compression); // Correct field for the schema

    if (image) {
      formData.append('image', image);
    }

    try {
      if (selectedProductId) {
        // Update Product
        await axios.put(`https://snapper.hxbindia.com/compressionproducts/${selectedProductId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        alert('Product updated successfully');
      } else {
        // Add Product
        await axios.post('https://snapper.hxbindia.com/compressionproducts', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        alert('Product added successfully');
      }
      setSelectedProductId('');
      setName('');
      setDescription('');
      setCompression(''); // Reset compression field
      setImage(null);
    } catch (error) {
      console.error('Error submitting product:', error);
      setError('Failed to submit product');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (productId) => {
    try {
      await axios.delete(`https://snapper.hxbindia.com/compressionproducts/${productId}`);
      alert('Product deleted successfully');
      setProducts(products.filter((product) => product._id !== productId));
    } catch (error) {
      console.error('Error deleting product:', error);
      setError('Failed to delete product');
    }
  };

  const handleSelectProduct = (product) => {
    setSelectedProductId(product._id);
    setName(product.name);
    setDescription(product.description);
    setCompression(product.compression._id); // Correct field
  };

  return (
    <div>
      <h2 style={{ textAlign: "center", color: "#333" }}>Compression Product Management</h2>
<hr />
      <form onSubmit={handleSubmit} className="container mt-4 border p-5">
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", minHeight: "80px" }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Compression Category</label>
          <select
            value={compression}
            onChange={(e) => setCompression(e.target.value)}
            required
            style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
          >
            <option value="">Select Compression</option>
            {compressions.map((comp) => (
              <option key={comp._id} value={comp._id}>
                {comp.name}
              </option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Image</label>
          <input type="file" accept="image/*" className="form-control" onChange={handleImageChange} />
        </div>

        <button
          className="btn btn-gradient-primary me-2"
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: loading ? "#888" : "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          {loading ? (selectedProductId ? "Updating..." : "Adding...") : selectedProductId ? "Update Product" : "Add Product"}
        </button>
      </form>

      {error && <div style={{ color: 'red' }}>{error}</div>}

      <h3>Product List</h3>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Compression</th>
                    <th>Image</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((product) => (
                    <tr key={product._id}>
                      <td>{product.name}</td>
                      <td>{product.description.length > 100 ? product.description.slice(0, 90) + "..." : product.description}</td>
                      <td>{compressions.find((comp) => comp._id === product.compression._id)?.name || 'Unknown'}</td>
                      <td>
                        {product.image && <img src={`https://snapper.hxbindia.com${product.image}`} alt={product.name} style={{ width: '50px', height: '50px' }} />}
                      </td>
                      <td>
                        <button onClick={() => handleSelectProduct(product)} className="btn btn-primary">Edit</button>
                        <button onClick={() => handleDelete(product._id)} className="btn btn-danger ms-2">Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div></div>
      </div>
    </div>
  );
};

export default CompressionPro;
